import SelfcarePageContent from "../../../components/selfcare/SelfcarePageContent";
import {Link} from "react-router-dom";
import Routing from "../../../Routing.ts";
import setTitleAndMetaDescription from "../../../components/setTitleAndMetaDescription.tsx";

export default function SbbuReceiptPage() {
    setTitleAndMetaDescription("Skift af udbyder - Mit Hiper", "Her kan du se og betale dine udestående regninger.");

    return <SelfcarePageContent title={'Tak!'}>
        <div className="flex flex-column flex-center">
            <p>
                Indsendelsen af din opsigelse til din nuværende udbyder er registreret.
            </p>
            <Link to={Routing.Selfcare.Index} className="button teal button--montserrat">Tilbage til overblik</Link>
        </div>
    </SelfcarePageContent>
}
